<div>
  <canvas #barChart></canvas>
</div>
